$(document).ready(function () {
    console.log('img.fs-lightbox');
   $('img.fs-lightbox').each(function () {
       $(this).parents('A').on('click', function (event) {
            event.preventDefault();
            $(this).ekkoLightbox({
                alwaysShowClose: true});
        })
    });
});